/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
import '@interactjs/dev-tools/plugin'
import interact from '@interactjs/interact/index'
import plugin from '@interactjs/dev-tools/plugin'
interact.use(plugin)